import { daysDuration } from '@/plugins/consts.js'
const moment = require('moment')

export function mapBackendProceduresToFrontend (procedures) {
  return procedures?.map(proc => {
    return {
      id: proc.id,
      title: proc.title,
      direction: proc.type === 'BUY' ? 1 : 2,
      stateId: proc.stateId,
      manager: proc.managerId,
      company: 0,
      participantsCount: proc.participantsCount,
      productCount: proc.productCount,
      dateCreated: proc.dateCreated,
      dateOpen: proc.dateOpen,
      dateAgreement: proc.dateAgreement,
      dateClosed: proc.dateClosed,
      viewedCount: proc.viewedCount,
      rating: proc.rating,
      priceMax: null,
      priceMin: null,
      priceAvg: null,
      minBidCount: 1,
      binCount: 1,
      contractId: 234524,
      inheritProcId: proc.inherit_proc_id
    }
  })
}

export function expiredAgreement (procedure) {
  if (procedure && procedure.stateId === 2) {
    return daysDuration(moment(procedure.dateAgreement), moment()) > 14
  } else {
    return false
  }
}

export function expiredRating (procedure) {
  if (procedure && procedure.stateId === 3 && procedure.date_delivery && procedure.rating === null) {
    return daysDuration(moment(procedure.date_delivery), moment()) > 14
  } else {
    return false
  }
}

export function minBidCountNotReached (procedure) {
  if (procedure) {
    return procedure.stateId === 1 && procedure.bin_count < procedure.min_bid_count
  } else {
    return false
  }
}
